module.exports = __webpack_public_path__ + "img/sys (2).f4f663da.png";